import React from 'react';


const FORM_INVALID_STATE = 1;


class DeinRezeptBlock extends React.Component {
    constructor(props) {
      super(props);
      this.state =this.props;
      
      // Scope der Componente muss zu Verfügung stehen ... muss für jede Methode gemacht werden!
      this.handleRezeptnameChange = this.handleRezeptnameChange.bind(this); 
      this.handleAnzahlPortionenChange = this.handleAnzahlPortionenChange.bind(this);
      this.handleFarbeChange = this.handleFarbeChange.bind(this);
      this.handleKochzeitChange = this.handleKochzeitChange.bind(this);
      this.handleCategorieChange = this.handleCategorieChange.bind(this);
    }
    // Handler des Rezeptname
    handleRezeptnameChange(event) {
      this.setState({ rezeptname: event.target.value });
      this.props.onRezeptnameChange(event.target.value);
    }
    // Handler des AnzahlPortionen
    handleAnzahlPortionenChange(event) {
      this.setState({ anzahlPortionen: event.target.value });
      this.props.onAnzahlPortionenChange(event.target.value);
    }
  
    // Handler des Farbe
    handleFarbeChange(event) {
      this.setState({ farbe: event.target.value });
      this.props.onFarbeChange(event.target.value);
    }
     // Handler des Kochzeit
     handleKochzeitChange(event) {
      this.setState({ kochzeit: event.target.value });
      this.props.onKochzeitChange(event.target.value);
    }
    // Handler des Kochzeit
    handleCategorieChange(event) {
      this.setState({ category_id: event.target.value });
      this.props.onCategoryChange(event.target.value);
    }
    render() {
      let rezeptnameValid =  ((this.props.rezeptnameIsValid === FORM_INVALID_STATE) ? 'invalid' : 'valid');
      
      return (
        <div className="Component Rezept">
        <h3>Dein Rezept</h3>
        <section className="flex2 center">
          <div className="formelement one flt hform">
              <label className={rezeptnameValid}>Rezeptname <span className="field-message">Bitte Rezeptnamen eingeben</span></label>
              <input type="text" name='rezeptname'  value={this.state.rezeptname} onChange={this.handleRezeptnameChange} maxLength="50" />
          </div>
          <div className="formelement three flt hform">
              <label>Portionen</label>
              <div className="select">
                <select value={this.state.anzahlPortionen} onChange={this.handleAnzahlPortionenChange} dir="rtl">
                <option value="1">1 Portion</option>
                <option value="2">2 Portionen</option>
                <option value="3">3 Portionen</option>
                <option value="4">4 Portionen</option>
                <option value="5">5 Portionen</option>
                <option value="6">6 Portionen</option>
                <option value="7">7 Portionen</option>
                <option value="8">8 Portionen</option>
                <option value="9">9 Portionen</option>
                <option value="10">10 Portionen</option>
              </select>
            </div>
          </div>

          <div className="formelement three flt hform">
              <label>Dauer</label>
              <div className="select">
              <select name='dauer' value={this.state.kochzeit} onChange={this.handleKochzeitChange} dir="rtl">
                <option value="5">5 Minuten</option>
                <option value="10">10 Minuten</option>
                <option value="15">15 Minuten</option>
                <option value="20">20 Minuten</option>
                <option value="25">25 Minuten</option>
                <option value="30">30 Minuten</option>
                <option value="45">45 Minuten</option>
                <option value="60">60 Minuten</option>
                <option value="90">90 Minuten</option>
                <option value="120">120 Minuten</option>
                <option value="180">180 Minuten</option>
                <option value="240">240 Minuten</option>
              </select>
            </div>
          </div>
          {/** 
          <div className="formelement six farbwahl center">
            <label>Farbwahl</label>
            <div className="farbwahlContainer">
              <div className="checkboxelement farbwahl blue">
                <input className="blue" type="radio" value="blau" 
                              checked={this.state.farbe === 'blau'} 
                              onChange={this.handleFarbeChange} />
                <label className="check-box blue"> 						</label>
              </div>
              <div className="checkboxelement farbwahl green">
                <input className="green" type="radio" value="gruen" 
                              checked={this.state.farbe === 'gruen'} 
                              onChange={this.handleFarbeChange} />
                <label className="check-box green"> </label>
              </div>
              <div className="checkboxelement farbwahl yellow">
                <input className="yellow" type="radio" value="gelb" 
                              checked={this.state.farbe === 'gelb'}
                              onChange={this.handleFarbeChange}  />
                <label className="check-box yellow"> </label>
              </div>
              <div className="checkboxelement farbwahl red">
                <input className="red" type="radio" value="rot" 
                              checked={this.state.farbe === 'rot'}
                              onChange={this.handleFarbeChange}  />
                <label className="check-box red"></label>
              </div>
            </div>
            <p>In welcher Farbe soll dein Rezept in unserer Heldenküche erscheinen? 		</p>
          </div>
          */}

          <div className="formelement six flt center">
            <div className="checkboxelement" name="selectFood">
            <input type="checkbox" value="1" 
                              checked={this.state.category_id === '1'} 
                              onChange={this.handleCategorieChange} />
              <label className="check-box"> </label>
              <p>Vorspeise</p>
            </div>

            <div className="checkboxelement">
            <input type="checkbox" value="2" 
                              checked={this.state.category_id === '2'} 
                              onChange={this.handleCategorieChange} />
              <label className="check-box"> </label>
              <p>Hauptgang</p>
            </div>

            <div className="checkboxelement">
            <input type="checkbox" value="3" 
                              checked={this.state.category_id === '3'} 
                              onChange={this.handleCategorieChange} />
              <label className="check-box"> </label>
              <p>Dessert</p>
            </div>

            
            <div className="checkboxelement">
            <input type="checkbox" value="4" 
                              checked={this.state.category_id === '4'} 
                              onChange={this.handleCategorieChange} />
              <label className="check-box"> </label>
              <p>Snack</p>
            </div>

            <div className="checkboxelement">
            <input type="checkbox" value="5" 
                              checked={this.state.category_id === '5'} 
                              onChange={this.handleCategorieChange} />
              <label className="check-box"> </label>
              <p>Getränk</p>
            </div>
            <div className="checkboxelement">
            <input type="checkbox" value="6" 
                              checked={this.state.category_id === '6'} 
                              onChange={this.handleCategorieChange} />
              <label className="check-box"> </label>
              <p>Gebäck</p>
            </div>
           
          </div>
        </section>
     


        
      
      
      </div>
           
      );
    }
  }

  export default DeinRezeptBlock;


// WEBPACK FOOTER //
// ./src/DeinRezeptBlock.js